import React, { useState } from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import OtpInput from 'react-otp-input';
import axios from 'axios';
import key from '../../key';
import { notification } from 'antd';
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';

const OtpVerification = () => {
    const { user } = useSelector(state => state.user)
    //eslint-disable-next-line
    const [cookies, setCookie, removeCookies] = useCookies(['x-auth-token']);
    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState();
    //eslint-disable-next-line
    const [email, setEmail] = useState(user?.email);
    const [generatedOTP, setGeneratedOTP] = useState();

    const onFinishEmail = async () => {
        setEmail(user?.email);
        try {
            const res = await axios.post(`${key}/api/user/check-email`, {
                email: user?.email
            });
            if (res.data.status) {
                // math.random() function to generate 4 digit OTP
                const otpp = Math.floor(1000 + Math.random() * 9000);
                setGeneratedOTP(otpp);
                await axios.post(`${key}/api/email/send-otp`, {
                    email: user?.email,
                    otp: otpp,
                });
                notification.success({
                    message: 'OTP sent successfully!',
                });
                setStep(2);
            } else {
                notification.error({
                    message: 'Error sending OTP, please try again later!',
                });
            }
        } catch (error) {
            notification.error({
                message: 'Error sending OTP, please try again later!',
            });
        }
    };

    const onFinishOTP = async () => {
        // Handle OTP submission
        //eslint-disable-next-line
        if (otp == generatedOTP) {
            notification.success({
                message: 'OTP verified successfully!',
            });

            await axios.get(`${key}/api/user/verify-account`, {
                headers: {
                    'x-auth-token': cookies['x-auth-token']
                },
            }).then(res => {
                if (res.data.success) {
                    setStep(3);
                    notification.success({
                        message: 'Account verified successfully!',
                    });
                    window.location.reload();
                } else {
                    notification.error({
                        message: 'Error verifying account, please try again later!',
                    });
                }
            }
            ).catch(err => {
                notification.error({
                    message: 'Error verifying account, please try again later!',
                });
            });
        } else {
            notification.error({
                message: 'OTP not verified!',
            });
        }

    };

    const renderStepContent = () => {
        switch (step) {
            case 1:
                return (
                    <Form className='email_form' name="forgot_password_form" onFinish={onFinishEmail}>
                        <Form.Item>
                            <label>Your Email</label>
                            <Input defaultValue={user?.email} readOnly />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Send OTP
                            </Button>
                        </Form.Item>
                    </Form>
                );
            case 2:
                return (
                    <Form>
                        <div className='head'>Enter the 4-Digit OTP</div>
                        <div className='d-flex justify-content-center'>
                            <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={4}
                                renderSeparator={<span>-</span>}
                                renderInput={(props) => <input {...props} />}
                                // inputType='number'
                                inputStyle='otp-input'
                            />
                        </div>
                        <div className='d-flex justify-content-center'>
                            <Button type="primary" onClick={onFinishOTP}>
                                Continue
                            </Button>
                        </div>
                    </Form>
                );
            case 3:
                return (
                    <div>
                        Congratulations! You have successfully verified your Account.
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <Row justify="center">
                <Col span={12}>
                    {renderStepContent()}
                </Col>
            </Row>
        </div>
    );
};

export default OtpVerification;
